import { buildCreateSlice } from '@reduxjs/toolkit';

import { CookieModalState } from '@widgets/CookieModals/model/types/cookieModalState';

const createAppSlice = buildCreateSlice({});

const initialState: CookieModalState = {
  aboutCookie: false,
  acceptCookie: false
};

export const cookieModalSlice = createAppSlice({
  name: 'cookieModal',
  initialState,
  reducers: (create) => ({
    openAboutCookieModal: create.reducer((state) => {
      state.aboutCookie = true;
    }),
    closeAboutCookieModal: create.reducer((state) => {
      state.aboutCookie = false;
    }),
    openAcceptCookieModal: create.reducer((state) => {
      state.acceptCookie = true;
    }),
    closeAcceptCookieModal: create.reducer((state) => {
      state.acceptCookie = false;
    })
  })
});

export const { openAboutCookieModal, closeAboutCookieModal, openAcceptCookieModal, closeAcceptCookieModal } =
  cookieModalSlice.actions;

export const cookieModalReducer = cookieModalSlice.reducer;
